import React, { useState } from "react";
import "../navbar.css";
import Navbar2 from "./navbar2";
import Footer from "./footer";
import { useNavigate } from "react-router-dom";
import { APIURL } from "../config";
import { FaEye, FaEyeSlash } from "react-icons/fa"; // Importing eye icons
import './registerpage.css'

function RegisterPage() {
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [firstNameError, setFirstNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [emailError, setEmailError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [confirmPasswordError, setConfirmPasswordError] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);  // State to toggle password visibility
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const toggleShowPassword = () => setShowPassword(!showPassword);
  const toggleShowConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

  const handleRegistration = async () => {
    // Reset previous errors
    setFirstNameError("");
    setLastNameError("");
    setEmailError("");
    setPasswordError("");
    setConfirmPasswordError("");
    setError("");

    // Basic Validations
    let isValid = true;  // Track validation status
    console.log("isValid: ", isValid)

    if (!firstName) {
      setFirstNameError("First Name is required.");
      isValid = false;
    }

    if (!lastName) {
      setLastNameError("Last Name is required.");
      isValid = false;
    }

    if (!email) {
      setEmailError("Email is required.");
      isValid = false;
    } else {
      // Email validation
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(email)) {
        setEmailError("Invalid email format.");
        isValid = false;
      }
    }

    if (!password) {
      setPasswordError("Password is required.");
      isValid = false;
    } else {
      // Password Strength Validation (at least 8 characters, 1 uppercase, 1 number)
      const passwordRegex = /^(?=.*[A-Z])(?=.*\d)[A-Za-z\d@$!%*?&]{8,}$/;

      if (!passwordRegex.test(password)) {
        setPasswordError("Password must be at least 8 characters long, contain one uppercase letter and one number.");
        isValid = false;
      }
    }

    if (!confirmPassword) {
      setConfirmPasswordError("Please confirm your password.");
      isValid = false;
    } else if (password !== confirmPassword) {
      setConfirmPasswordError("Passwords do not match.");
      isValid = false;
    }
    console.log("isValid1: ", isValid)
    // Stop execution if any validation fails
    if (isValid == false) {
      setError("Please fill in all fields correctly.");
      console.log("isValid2: ", isValid)
      return;
    }
    // Proceed with API call only if validation passes
    try {
      const response = await fetch(`${APIURL}/createaccount`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ firstName, lastName, email, password }),
      });

      const data = await response.json();
      if (data.message === "Account created Successfully!") {
        console.log("Navigating to login...");
        navigate("/login");
      } else {
        setError(data.message || "An error occurred. Please try again.");
      }
    } catch (error) {
      console.error("Error:", error);
      setError("An error occurred while creating an account.");
    }
  };


  return (
    <div>
      <div className="loginsignup">
        <div className="loginsignup-container">
          <h1>Register</h1>
          <div className="loginsignup-fields">
            <label>
              First Name
              <br />
              <input
                type="text"
                className="firstName"
                placeholder="Enter your first name"

                style={{ width: "540px", height: "45px" }}
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
              />
              <span style={{ color: "red" }}>{firstNameError}</span>
            </label>
            <br />
            <label>
              Last Name
              <br />
              <input
                type="text"
                className="lastName"
                placeholder="Enter your last name"
                style={{ width: "540px", height: "45px" }}
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
              />
              <span style={{ color: "red" }}>{lastNameError}</span>
            </label>
            <br />
            <label>
              Email Address
              <br />
              <input
                type="email"
                className="email"
                placeholder="Enter your email address"
                style={{ width: "540px", height: "45px" }}
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
              <span style={{ color: "red" }}>{emailError}</span>
            </label>
            <br />
            <label>
              Password
              <br />

              <div className="password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  className="password-input"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your password"
                />
                <span style={{
                  position: 'absolute',
                  right: '10px',
                  cursor: 'pointer',
                  color: "#6c6c7d"
                }} className="eye-button" onClick={toggleShowPassword}>
                  {
                    showPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />
                  }              </span>
              </div>
              <span style={{ color: "red" }}>{passwordError}</span>
            </label>
            <br />
            <label>
              Confirm Password
              <br />
              <div className="password-container">
                <input
                  type={showPassword ? "text" : "password"}
                  className="password-input"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  placeholder="Enter confirm password"
                />
                <span style={{
                  position: 'absolute',
                  right: '10px',
                  cursor: 'pointer',
                  color: "#6c6c7d"
                }} className="eye-button" onClick={toggleShowConfirmPassword}>
                  {
                    showConfirmPassword ? <FaEyeSlash size={20} /> : <FaEye size={20} />
                  }              </span>
              </div>
              <span style={{ color: "red" }}>{confirmPasswordError}</span>
            </label>
          </div>
          <br />
          <button className="submit-button" onClick={handleRegistration}>
            Submit
          </button>
          {error && <p style={{ color: "red" }}>{error}</p>}
          <br />
                    <br/>
          
           <a
            style={{ cursor: "pointer" }}
            className="register"
            onClick={() => navigate("/login")}
          >
          Already have an account? Login
          </a>
          <br/>
                    <br/>

          <p className="register-data">
            Petivity Analysis Kits are not for diagnostic purposes. Information provided by these kits is not intended to diagnose, treat, cure, or prevent any disease. Information is intended for optimizing pet health & wellbeing. We recommend regular wellness check-ups with your Veterinarian. If you want to address a symptom, we recommend consulting with your Veterinarian.
          </p>
        </div>
      </div >
    </div >
  );
}

export default RegisterPage;
